import { useState } from 'react'

import config from 'config'
import { ProductSearchResult } from 'models/SearchResult'
import { useAuth0Authentication } from './useAuth0Authentication'

export interface IUseProductVersions {
    productVersions: ProductSearchResult[],
    isLoading: boolean,
    getProductVersions: (productId: string) => void,
}

export const useProductVersions = () => {

    const [productVersions, setProductVersions] = useState<ProductSearchResult[]>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const getProductVersions = async (productId: string) => {

        setIsLoading(true)
  
        const accessToken: string = await getAuth0AccessToken()
  
        const response = await fetch(
        `${config.apiUrl}/products/get/${productId}/versions`
            , {
            method: 'GET',
            redirect: 'follow',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": 'application/json'
            },
            }
        )
    
        const productVersionsResp: ProductSearchResult[] = await response.json()
        setProductVersions(productVersionsResp)
        setIsLoading(false)
      }

    
      const { getAuth0AccessToken } = useAuth0Authentication()



    return {
        productVersions,
        isLoading,
        getProductVersions
    }
}